import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
const useStyles = makeStyles()(theme => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[1],
        fontSize: theme.typography.fontSize,
    },
    popper: {
        opacity: 1,
    },
}));
const TooltipNext = ({ children, classes: customClasses, ...rest }) => {
    const { classes, cx } = useStyles();
    return (_jsx(Tooltip, { classes: {
            ...customClasses,
            tooltip: cx(classes.tooltip, customClasses?.tooltip),
            popper: cx(classes.popper, customClasses?.popper),
        }, enterTouchDelay: 100, ...rest, children: children || _jsx(InfoIcon, {}) }));
};
export { TooltipNext };
